import React, { FC } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import styled from 'styled-components';
import { Row, Col } from 'styled-bootstrap-grid';

import { Player } from '../../../../../database.schema';

const PlayerX = styled.div`
  height: 2rem;
  padding: 5px;
  width: 8rem;
  background: darkgrey;
  text-align: center;
  border: 1px solid grey;
  border-radius: 0.25rem;
  margin: 0.25rem;
`;

const Team1Wrapper = styled.div`
  border: 1px solid black;
  border-radius: 0.25rem;
  width: 100%;
  background-color: red;
  color: white;
  padding: 5px;
  min-height: 4rem;
  display: flex;
  justify-content: center;
`;
const Team2Wrapper = styled.div`
  border: 1px solid black;
  border-radius: 0.25rem;
  width: 100%;
  background-color: blue;
  color: white;
  padding: 5px;
  min-height: 4rem;
  display: flex;
  justify-content: center;
`;

const PlayerContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

type TeamDropBoxProps = {
  team1: Array<Player>;
  team2: Array<Player>;
};

export const TeamDropBoxes: FC<TeamDropBoxProps> = ({ team1, team2 }): JSX.Element => {
  return (
    <Row>
      <Col col={6}>
        <h3>Team 1</h3>
        <Team1Wrapper>
          <Droppable droppableId="team1" isDropDisabled={team1.length === 5}>
            {(provided, snapshot): JSX.Element => (
              <PlayerContainer {...provided.droppableProps} ref={provided.innerRef} style={{ width: '100%', height: '100%', minHeight: '4rem' }} data-testid="team1-players">
                {team1.map((player: Player, index) => (
                  <PlayerX key={player.nickName}>{player.nickName}</PlayerX>
                ))}
                {provided.placeholder}
              </PlayerContainer>
            )}
          </Droppable>
        </Team1Wrapper>
      </Col>
      <Col col={6}>
        <h3>Team 2</h3>
        <Team2Wrapper>
          <Droppable droppableId="team2" isDropDisabled={team2.length === 5}>
            {(provided, snapshot): JSX.Element => (
              <PlayerContainer {...provided.droppableProps} ref={provided.innerRef} style={{ width: '100%', height: '100%', minHeight: '4rem' }} data-testid="team2-players">
                {team2.map((player: Player, index) => (
                  <PlayerX key={player.nickName}>{player.nickName}</PlayerX>
                ))}
                {provided.placeholder}
              </PlayerContainer>
            )}
          </Droppable>
        </Team2Wrapper>
      </Col>
    </Row>
  );
};
